import Printd from 'printd';
export default {
  name: 'lm-handover-logs',
  components: {  Printd  },
  props: ['payload'],
  data() {
    return {
      handoverlogdata: JSON.parse(JSON.stringify(this.payload)),
    }
  },
  mounted() {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/LMHandoverLog/LMHandoverLogPdf/lmhandoverlogpdf.component.js